import GeocoderResult from 'tickets/utils/geocoderResult'
import actions from './actions'
import searchParamsOperations from 'tickets/redux/modules/searchParams/operations'
import locationOperations from 'tickets/redux/modules/location/operations'

const changeOriginLongName = actions.changeOriginLongName
const changeDestinationLongName = actions.changeDestinationLongName

const changeOriginShortName = actions.changeOriginShortName
const changeDestinationShortName = actions.changeDestinationShortName

const changeOriginGooglePlaceId = actions.changeOriginGooglePlaceId
const changeDestinationGooglePlaceId = actions.changeDestinationGooglePlaceId

const initialiseOrigin = (originCanonical, languageCode) => geocodeInitial(originCanonical, true, languageCode)
const initialiseDestination = (destinationCanonical, languageCode) => geocodeInitial(destinationCanonical, false, languageCode)
const geocodeInitial = (canonical, isOrigin, languageCode) => (dispatch) => {
  const geocoderPromise = new Promise(
     (resolve) => {
       GeocoderResult.getGeocoderResult(canonical, languageCode)
         .then(response => {
            if (isOrigin) {
              dispatch(locationOperations.changeOriginLongName(response.longName))
              dispatch(locationOperations.changeOriginShortName(response.shortName))
              dispatch(locationOperations.changeOriginGooglePlaceId(response.googlePlaceId))
              dispatch(searchParamsOperations.updateOriginKind(response.kind))
              dispatch(searchParamsOperations.updateOriginLatLng(response.latlng))
            } else {
              dispatch(locationOperations.changeDestinationLongName(response.longName))
              dispatch(locationOperations.changeDestinationShortName(response.shortName))
              dispatch(locationOperations.changeDestinationGooglePlaceId(response.googlePlaceId))
              dispatch(searchParamsOperations.updateDestinationKind(response.kind))
              dispatch(searchParamsOperations.updateDestinationLatLng(response.latlng))
            }
            resolve()
          })
          // If the initial geocode failed, that's ok. Swallow the rejection.
          .catch(() => {})
    }
  )
  return geocoderPromise
}

export default {
  changeOriginLongName,
  changeDestinationLongName,
  changeOriginShortName,
  changeDestinationShortName,
  changeOriginGooglePlaceId,
  changeDestinationGooglePlaceId,
  initialiseOrigin,
  initialiseDestination,
}
